export function fmtMoney(n: number | null | undefined, ccy = 'CAD'): string {
  return new Intl.NumberFormat('en-CA', { style: 'currency', currency: ccy }).format(n ?? 0);
}

export function fmtDate(iso: string | null | undefined): string {
  return iso ? new Date(iso).toLocaleDateString('en-CA') : '—';
}

export function fmtDateTime(iso: string | null | undefined): string {
  return iso ? new Date(iso).toLocaleString('en-CA') : '—';
}
